<template>
  <div>
    <CardAlert class="mt-4 mx-4" :color="getThemeColor">
      <v-toolbar
        dark
        :style="{ background: getThemeColor, color: 'white' }"
        shaped
        max-width="344"
      >
        <!-- <v-toolbar-title>{{ getCompanyLabels.services }}</v-toolbar-title> -->
        <v-autocomplete
          prepend-inner-icon="search"
          v-model="selectedSalaryID"
          :items="salaries"
          item-text="name"
          item-value="id"
          class="ml-4"
          flat
          hide-no-data
          hide-details
          :label="'Select Salary'"
          solo-inverted
          @change="getSelectedSalary()"
        ></v-autocomplete>
        <v-btn icon @click="openGlobalDialogSlot()">
          <v-icon small>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
    </CardAlert>

    <GlobalDialogSlot
      :title="title"
      :dialog="dialog"
      @close-dialog="dialog = false"
    >
      <CreateSalary
        @salary-created="getNewSalary"
        @exist="title = 'Item Exist'"
      ></CreateSalary>
    </GlobalDialogSlot>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import CreateSalary from "@/components/StaffAndHR/CreateSalary.vue";
import CardAlert from "@/components/myLibrary/CardAlert.vue";

export default {
  components: { GlobalDialogSlot, CreateSalary, CardAlert },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  mounted() {
    this.getAllSalaries();
  },
  data: () => ({
    dialog: false,
    title: "Create Salary",
    salaries: [],
    selectedSalaryID: null,
  }),
  methods: {
    getAllSalaries() {
      this.$store.commit("setLoader", true);
      axios
        .getData("/auth/get-all-salaries", this.getAccessToken)
        .then((salaries) => {
          this.salaries = salaries;
          this.$store.commit("setLoader", false);
        });
    },
    getNewSalary(salary) {
      this.salaries.push(salary);
      this.$emit("salary-selected", salary.id);
      this.dialog = false;
    },
    getSelectedSalary() {
      this.$emit("salary-selected", this.selectedSalaryID);
    },
    openGlobalDialogSlot() {
      this.dialog = true;
    },
  },
};
</script>

<style></style>
